import { queryOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";

interface Memory {
	context: string;
}

interface MemoryNode {
	id: string;
	name: string;
	kind: "folder" | "file";
	mimeType: string | null;
	size: number | null;
	// What the agent reads of a file. Null on a folder and on a file not read yet.
	indexStatus: "indexed" | "unreadable" | "unsupported" | "too_long" | null;
	createdAt: string;
}

export const memoryContextQueryOptions = queryOptions({
	queryKey: ["memory", "context"],
	queryFn: () => api.get<Memory>("/platform/memory/context"),
});

// A null parentId is the root directory.
export const memoryFilesQueryOptions = (parentId: string | null) =>
	queryOptions({
		queryKey: ["memory", "files", parentId],
		queryFn: () =>
			api.get<MemoryNode[]>(
				parentId ? `/platform/memory/files?parentId=${parentId}` : "/platform/memory/files",
			),
	});
